import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { YourWorkItemListSkeleton } from '@atlassian/jira-skeletons/src/ui/your-work/YourWorkItemListSkeleton.tsx';
import type { TabConfig } from '../../common/types/tabs.tsx';

const FullSkeleton = ({
	tabConfigs,
	deepDiveCards,
}: {
	tabConfigs: TabConfig[];
	deepDiveCards: ReactNode;
}): React.JSX.Element => (
	<TabWrapper>
		{deepDiveCards}
		<Box xcss={navigationWrapperStyles}>
			<Navigation>
				{tabConfigs.map((tab: TabConfig) => (
					<NavItem key={tab.id}>&nbsp;&nbsp;&nbsp;&nbsp;</NavItem>
				))}
				<NavLine />
			</Navigation>
		</Box>
		<YourWorkItemListSkeleton />
	</TabWrapper>
);

export default FullSkeleton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TabWrapper = styled.div({
	margin: 0,
	padding: 0,
});

const navigationWrapperStyles = xcss({
	marginLeft: 'space.negative.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Navigation = styled.div({
	position: 'relative',
	display: 'flex',
	fontWeight: token('font.weight.medium'),
	listStyleType: 'none',
	margin: 0,
	padding: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NavLine = styled.span({
	backgroundColor: token('color.border'),
	borderRadius: token('radius.xsmall'),
	bottom: 0,
	content: "''",
	height: '2px',
	left: token('space.100'),
	margin: 0,
	position: 'absolute',
	right: token('space.100'),
	width: 'inherit',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NavItem = styled.div({
	backgroundColor: token('color.background.neutral.pressed'),
	marginTop: token('space.100'),
	marginRight: token('space.100'),
	marginBottom: token('space.100'),
	marginLeft: token('space.100'),
	paddingTop: 0,
	paddingBottom: 0,
	paddingLeft: token('space.100'),
	paddingRight: token('space.100'),
	borderRadius: token('radius.small'),
	font: token('font.body'),
	width: '4em',
});
